import { render } from "./ConfermaModal.vue?vue&type=template&id=05f84597&ts=true"
import script from "./ConfermaModal.vue?vue&type=script&lang=ts"
export * from "./ConfermaModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__